export default __webpack_public_path__ + "static/media/womencloth.2697e0eb.svg";